import { atom } from 'recoil';
import { localAtom } from '../localStorageState';

export type Timezone = {
  label: string;
  description?: string;
  /**
   * Offset in hours. Only a snapshot for display: it is correct for the moment the list was built,
   * so anything resolving a specific date must go through `zone` instead.
   */
  offset: number;
  /** IANA zone name. Absent for the viewer's own zone, which Luxon already resolves. */
  zone?: string;
  isLocal?: boolean;
};

export const withCurrentTimezone = localAtom<Timezone>({
  key: 'timezone.currentTimezone',
  default: { label: '', description: '', offset: 0 }
});

export const withGlobalTimeDiff = atom<number>({
  key: 'globalTimeDiff',
  default: 0
});
